
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Link from 'components/Link'
import Icon from 'components/Icon'
import propsChanged from 'utils/propsChanged'
import classnames from 'classnames'

export default class VerticalTabs extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
    className: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = {
      opened: null
    }
  }

  componentWillMount() {
    this.handleComponentChange(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (propsChanged(this.props, nextProps, ['activeItemId'])) {
      this.handleComponentChange(nextProps)
    }
  }

  render() {
    const {items, className} = this.props
    const classNames = classnames('vertical-tabs', className)
    return (
      <div className={classNames}>
        {items.map((item, index) => {
          if (item.items) {
            return this.renderItemsFolder(item, index)
          } else {
            return this.renderItem(item, index)
          }
        })}
      </div>
    )
  }

  renderItemsFolder(item, index) {
    const {opened} = this.state
    const classNames = classnames('vertical-tabs_folder', {
      'is-opened': opened
    })

    return (
      <div className={classNames} key={index}>
        <div className='vertical-tabs_folder_title' onClick={this.openFolder}>
          {item.label}
          <Icon className='vertical-tabs_folder_icon' name='chevron' size='10px' />
        </div>
        <div className='vertical-tabs_folder_items'>
          {item.items.map((item, index) => this.renderItem(item, index))}
        </div>
      </div>
    )
  }

  renderItem(item, index) {
    return (
      <Link
        to={item.to}
        className='vertical-tabs_item'
        key={index}
      >
        {this.renderIcon(item)}
        <span className='vertical-tabs_item_label'>{item.label}</span>
        {this.renderBadge(item)}
      </Link>
    )
  }

  renderIcon(item) {
    const {iconName} = item
    if (!iconName) return null

    return <Icon className='vertical-tabs_item_icon' name={iconName} size='22px' />
  }

  renderBadge(item) {
    const {badge} = item
    if (!badge) return null

    return <span className='vertical-tabs_item_badge'>{badge}</span>
  }

  handleComponentChange(props) {
    const {items, activeItemId} = props

    const itemWithItems = items.find(item => item.items)
    if (!itemWithItems) return

    if (itemWithItems.items.find(item => item.key === activeItemId)) {
      this.setState({
        opened: true
      })
    }
  }

  openFolder = () => {
    const {opened} = this.state

    this.setState({
      opened: !opened
    })
  }
}



// WEBPACK FOOTER //
// ./client/components/VerticalTabs/index.js